
<template>
  <div>
    <!-- <v-select label="Gerente responsável" v-if="manager"
      :readonly="readonly"
      :rules="required"
      :loading="loading.employees"
      :items="managers" 
      item-text="attributes.name" 
      item-value="attributes.id"
      prepend-icon="mdi-account-box"
      v-model="order.manager_id"
      :menu-props="{ bottom: true, offsetY: true }"
      @click:clear="clearManager()"
      :clearable="!readonly"
    ></v-select> -->
    <v-select label="Vendedor responsável" 
      :readonly="readonly"
      :loading="loading.employees"
      :rules="required"
      :items="sellers" 
      item-text="attributes.name" 
      item-value="attributes.id"
      prepend-icon="mdi-account"
      v-model="order.employee_id"
      :menu-props="{ bottom: true, offsetY: true }"
      :clearable="!readonly"
      @click:clear="clearSeller()"
    ></v-select>
    <v-text-field v-if="order.created_by_name" label="Pedido criado por" v-model="order.created_by_name" 
      disabled prepend-icon="mdi-note-plus"></v-text-field>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Api from '@/api/index'
import validations from '@/mixins/validations'

export default {
  name:'SelectSellerAndManager',
  props: {
    order: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false
    },
    manager:{
      type: Boolean,
      default: true
    }
  },
  mixins: [ validations ],
  data() {
    return {
      employees: [],
      loading: {
        employees: false
      }
    }
  },
  computed: {
    sellers(){
      return this.employees
    },
    managers(){
      let manager_role_id = 3
      return this.employees.filter( el => el.attributes.role_ids.includes(manager_role_id) )
    },
  },
  methods: {
    clearManager(){
      this.order.manager_id = null
    },
    clearSeller(){
      this.order.employee_id = null
    },
    getData(){
      this.getEmployees()
    },
    setSellerAndManagerByCurrentUser(){
      if(this.isSeller()){
        this.order.employee_id = this.current_user_employee_id
      }
      if(this.isManager()){
        this.order.manager_id = this.current_user_employee_id
      }
    },
    getEmployees(){
      this.employees = []
      let params = this.getEmployeesParams()
      this.loading.employees = true
      Api.Employee.index(params).then(res => res.data).then(data => {
        this.employees = data.data
        this.setSellerAndManagerByCurrentUser()
      }).finally(() => {
        this.loading.employees = false
      })
    },
    getEmployeesParams(){
      let params = {
        short: true,
        by_roles: ["Manager", "Seller"],
        modality_ids: [this.order.modality_id],
        modality_id: this.order.modality_id
      }
      if((this.order.client_id || this.order.is_default_client) && !this.order.without_client){
        params = {
          ...params,
          client_id: this.order.is_default_client ? -1 : this.order.client_id,
        }
      }
      return params
    }
  },
  mounted () {
    this.getData();
  },
  watch: {
    'order.client_id'(nv) {
      if( nv ){
        this.getData();
      }
    },
    'order.is_default_client'(nv) {
      if( nv){
        this.getData();
      }
    },
    'order.without_client'(nv) {
      if( nv ){
        this.getData();
      }
    },
  },
}
</script>